import { render, staticRenderFns } from "./MenuCategorizacion.vue?vue&type=template&id=5395aa16&"
import script from "./MenuCategorizacion.vue?vue&type=script&lang=js&"
export * from "./MenuCategorizacion.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategorizacion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports